<div >
    <canvas #timeChartCanvas class="customWidth"></canvas>
</div>
